
import React, { Component } from 'react';

import { setNewPassword } from '../utils/forgot-password';

class NewUserPassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            newPassword: '',
            confirmPassword: ''
        };
    }  
 
    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    };
  
handleNewPassword = async (e) => {
    e.preventDefault(); // Prevent page refresh
    const { username, onLogin } = this.props;
    const { newPassword, confirmPassword } = this.state;

    const passwordRegex = /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&.])[A-Za-z\d@$!%*?&.]{8,}$/;

    if (newPassword !== confirmPassword) {
        alert("Passwords do not match!");
        return;
    }

    if (!passwordRegex.test(newPassword)) {
        alert("Password must be at least 8 characters long, contain one uppercase letter, one number, and one special character.");
        return;
    }

    try {
        const result = await setNewPassword(username, newPassword);
        if (result.success) {
            onLogin();
        } else {
            alert("Password reset failed. Please try again.");
        }
    } catch (error) {
        console.error("Error Occurs", error);
        alert("Failed to reset password. Please check your details and try again.");
    }
};


    render() {
        console.log('Users View')
        return (
            <div className='swagger-ui'>
                <div className='newpassword-container'>
                    <div className='forgot-heading'>
                        <span className='forgot-form-heading'>Set New Password</span>
                    </div>
                    <form className='newpassword-form' onSubmit={this.handleNewPassword}>

                        <label className='newpassword-label2'>New Password</label>
                        <input
                            type='password'
                            name='newPassword'
                            value={this.state.newPassword}
                            onChange={this.handleChange}
                            className='newpassword-input'
                        />

                        <label className='newpassword-label'>Confirm Password</label>
                        <input
                            type='password'
                            name='confirmPassword'
                            value={this.state.confirmPassword}
                            onChange={this.handleChange}
                            className='newpassword-input'
                        />

                        <button type="submit" className='submit-button'>Submit</button>
                    </form>
                </div>
            </div>
        );
    }
}

export default NewUserPassword;
